"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _globals = _interopRequireDefault(require("@insided/shared/utils/globals"));

var _EmptyPage = _interopRequireDefault(require("@insided/deprecated-preact-components/empty-page/EmptyPage"));

var _preactCompat = require("preact-compat");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var EmptyView = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(EmptyView, _PureComponent);

  var _super = _createSuper(EmptyView);

  function EmptyView() {
    (0, _classCallCheck2.default)(this, EmptyView);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(EmptyView, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          EmptyStateComponent = _this$props.EmptyStateComponent,
          loading = _this$props.loading,
          showNoResultFound = _this$props.showNoResultFound;
      var emptyPageUrl = "".concat((0, _globals.default)('basePath'), "images/empty_result.png");

      if (loading) {
        return null;
      }

      return showNoResultFound ? (0, _preact.h)(_EmptyPage.default, {
        img_src: emptyPageUrl,
        header: "No results found",
        text: 'Sorry, that filter combination has no results.\n Please try different criteria.'
      }) : EmptyStateComponent;
    }
  }]);
  return EmptyView;
}(_preactCompat.PureComponent);

var _default = EmptyView;
exports.default = _default;